import React from 'react';
import { Alert, Container } from 'reactstrap';
import DepositsTable from './components/DepositsTable';
import StandardLayout from '@/common/layouts/StandardLayout';

const DepositsPage: React.FC = () => {
  return (
    <StandardLayout pageTitle="Deposits">
      <DepositsTable />
    </StandardLayout>
  );
};

export default DepositsPage;
